import {
  Badge,
  Button,
  Group,
  HoverCard,
  Modal,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from "@mantine/core";
import { IconHelpCircle } from "@tabler/icons-react";
import { useState } from "react";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import { useLanguage } from "../../../../../stores/LanguageStore";
import { useSessionStore } from "../../../../../stores/UserStore";
import { updateProfile, updateSelf } from "../../../../../api/UserAPI";

const PopupNew = () => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(true);
  const setNodes = useFlowStore((s) => s.setNodes);
  const setEdges = useFlowStore((s) => s.setEdges);
  const setLayout = useFlowStore((s) => s.setLayout);
  // const navigate = useNavigate()

  const onGoToNew = () => {
    let switched = !!useSessionStore.getState().user_switch;

    if (!switched) {
      updateProfile(null, { show_new_workflow_builder: true }).then(() =>
        updateSelf(),
      );
    }
    setLayout("horizontal");
    setNodes([]);
    setEdges([]);
    setOpened(false);
  };

  const onStay = () => {
    let switched = !!useSessionStore.getState().user_switch;
    if (!switched) {
      updateProfile(null, { show_new_workflow_builder: false }).then(() =>
        updateSelf(),
      );
    }

    setOpened(false);
  };

  return (
    <Modal
      opened={opened}
      onClose={() => setOpened(false)}
      centered
      size={"lg"}
      overlayProps={{ blur: 2, backgroundOpacity: 0.5 }}
    >
      <Stack align="center">
        <Badge color="#ffd6d6" c={"black"} size="lg" radius="xl" align="center">
          {lang.campaign.popup_new.badge_new}
        </Badge>

        <Title order={3} ta={"center"}>
          {lang.campaign.popup_new.title}
        </Title>

        <Group pos={"relative"}>
          <Button
            size="lg"
            leftSection={
              <Badge color="#ffd6d6" c={"black"}>
                {lang.campaign.popup_new.badge_beta}
              </Badge>
            }
            radius={"lg"}
            onClick={onGoToNew}
          >
            {lang.campaign.popup_new.btn_test_new}
          </Button>
          <HoverCard zIndex={900} position="top" width={300} withArrow>
            <HoverCard.Target>
              <ThemeIcon
                color="secondary"
                radius={"xl"}
                variant="light"
                size={"lg"}
                pos={"absolute"}
                right={-64}
              >
                <IconHelpCircle size={24} />
              </ThemeIcon>
            </HoverCard.Target>
            <HoverCard.Dropdown>
              <Text>{lang.campaign.popup_new.tooltip_info}</Text>
            </HoverCard.Dropdown>
          </HoverCard>
        </Group>

        <Button
          size="lg"
          variant="outline"
          c={"black"}
          radius={"lg"}
          mt={8}
          onClick={onStay}
        >
          {lang.campaign.popup_new.btn_stay_old}
        </Button>
      </Stack>
    </Modal>
  );
};

export default PopupNew;
